import React from 'react';
import './AboutProject.css';

export default function AboutProject() {
  return (
    <section id='about' className='about'>
      <h2 className='about__title'>About the Project</h2>
      <ul className='about__project'>
        <li className='about__project-item'>
          <h3 className='about__project-subtitle'>The Inspiration</h3>
          <p className='about__project-text'>This project grew from the rich history of our school and the remarkable people who have dedicated their lives to shaping students’ futures. Over more than three decades, our photography captures more than just moments—it tells real stories of triumph, struggle, sacrifice, and unwavering dedication. Every photograph here is a piece of that story. When you see your own, remember: you are part of something truly extraordinary.</p>
        </li>
        <li className='about__project-item'>
          <h3 className='about__project-subtitle'>The Work</h3>
          <p className='about__project-text'>Building this online application was a journey that took five weeks. The first week focused on the backend—the invisible engine storing and delivering all the data. The next four weeks were spent crafting the frontend, shaping the design, layout, content, and interactive features that you experience on your screen. Some tasks felt impossible at first, each one a tiny puzzle that wouldn’t let go until solved. In the end, every challenge became part of the story behind this project, just like the stories captured in the photos themselves.</p>
        </li>
      </ul>
      <div className='about__week'>
        <h4 className='about__week-style about__week-subtitle about__week-subtitle_mod'>1 week</h4>
        <h4 className='about__week-style about__week-subtitle'>4 weeks</h4>
        <p className='about__week-style about__week-description'>Backend</p>
        <p className='about__week-style about__week-description'>Frontend</p>
      </div>
    </section>
  );
};
